import {
  divWithStyle,
  flexRowStyle,
  vizPortalFontStyle,
} from '@tableau/data-catalog-shared';
import { TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Formatters } from '../../../gen-src/Localize';

// Styles from Vizportal "Spaces Explorer"
const ItemContainer = divWithStyle('ItemContainer', {
  ...flexRowStyle,
  justifyContent: 'space-between',
  whiteSpace: 'nowrap',
  padding: '6px 0',
  fontFamily: vizPortalFontStyle.fontFamily,
});

const CountLabel = divWithStyle('CountLabel', {
  minWidth: 36,
  marginLeft: TabStyles.Spacing.MediumSpace,
  textAlign: 'right',
  color: TabStyles.Typography.Color.Disabled,
});

export type CatalogBrowserSelectorItemProps = {
  readonly subplaceName: string;
  readonly count: number | null;
};

export function CatalogBrowserSelectorItem(
  props: CatalogBrowserSelectorItemProps
): JSX.Element {
  return (
    <ItemContainer>
      <div>{props.subplaceName}</div>
      <CountLabel>
        {props.count ? Formatters.formatCount(props.count) : null}
      </CountLabel>
    </ItemContainer>
  );
}
